import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import AssignedToSelector from '@/shared/components/input/AssignedToSelector';
import messages from '../taskMessages';

export default class ChangeAssignedUserModal extends Component {
  state = {
    selectedAssignedTo: {
      assignedType: 0,
      assignedUserId: null,
      assignedProfile: null,
    },
  };

  componentDidMount() {
    this.form = React.createRef();
  }

  static propTypes = {
    onSave: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
  };

  assignedToChanged = assignedTo => {
    this.setState(state => ({
      ...state,
      selectedAssignedTo: assignedTo,
    }));
  };

  onSave = () => {
    const { selectedAssignedTo } = this.state;
    const { onSave } = this.props;
    return onSave(selectedAssignedTo);
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl } = this.props;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeAssignedUser)}
        show={show}
        onClose={this.closeModal}
        onSave={this.onSave}
      >
        {show && (
          <form ref={this.form}>
            <div className="form-horizontal">
              <div className="form-group">
                <label className="control-label col-sm-3">
                  {intl.formatMessage(messages.User)}
                </label>
                <div className="col-md-6">
                  <AssignedToSelector onChange={this.assignedToChanged} showReset />
                </div>
              </div>
            </div>
          </form>
        )}
      </OkCancelModal>
    );
  }
}
